import React, { useEffect, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import LockResetIcon from '@mui/icons-material/LockReset';

const RenderPasswordTextfield = ({
  data,
  ind,
  textValue,
  handleTextValue,
  index,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    const externalValue = textValue[data?.component?.sName];
    if (externalValue !== undefined && externalValue !== password) {
      setPassword(externalValue ?? "");
    }
  }, [textValue[data?.component?.sName]])

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const generateRandomPassword = (length, data, ind) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*_+|:.?";
    let password = "";
    
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      password += chars[randomIndex];
    }

    const e = {
        target: {
            name: data?.component?.sName,
            value: password
        }
    }
    setPassword(password);
    handleTextValue(e, ind, data?.validation);
  }

  return (
    <Grid item {...data?.grid_props}>
      <TextField
        id={data?.component?.sName}
        label={data?.component?.sLabel}
        placeholder={data?.component?.sPlaceHolder}
        defaultValue={data?.component?.sDefaultValue || ""}
        variant={data?.component?.sProps?.variant}
        helperText={(error?.hasOwnProperty(data?.component?.sName) && error[data?.component?.sName] != null) ? error[data?.component?.sName] || " " : (data?.component?.sHelper ? data?.component?.sHelper : " ")}
        value={password}
        name={data?.component?.sName}
        onChange={(e) => {
            setPassword(e.target.value);
            handleTextValue(e, ind, data?.validation);
        }}
        error={error && (error[data?.component?.sName] || (error?.hasOwnProperty(data?.component?.sName) && error[data?.component?.sName] != null))}
        {...data?.component?.sProps}
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
                {data?.component?.options?.mode == "GENERATE" && <IconButton
                onClick={() => {
                    generateRandomPassword(data?.validation?.iMaxLen, data, ind)
                }}
                edge="end"
              >
                <LockResetIcon />
              </IconButton>}
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        // {...data?.component?.sProps}
      />
    </Grid>
  );
};

export default RenderPasswordTextfield;
